export const APP_NAME = 'Early Bird'
export const BEACON_ID = 'a3fcfc35-2f63-4bec-9d6b-3aeb4819a664'
export const QUERY_STALE_TIME = 1000 * 60
export const BIS_AVG_CONVERSION_RATE = 18
